import Vue from "vue";
import Router from "vue-router";

// 菜单框架页面
import layout from "@/frame/layout/index.vue";

// 未开发的页面
import notFind from "@/frame/not_find/not_find.vue";

Vue.use(Router);

export let routes: any[] =[
    {
    path: "/",
    component:layout,
    children: [
      {
        path: "home",
        component: () => import("@/views/home_page/index.vue")
      },
      {
        path: "into",
        component: () => import("@/views/into_feiyuan/index.vue")
      },
      {
        path: "technical",
        component: () => import("@/views/technical_services/index.vue"),
        children: [
          {
            path: "consultants",
            component: () => import("@/views/technical_services/environmental_consultants/environmental_consultants.vue")
          },
          {
            path: "smart_ep",
            component: () => import("@/views/technical_services/smart_environmental_protection/smart_environmental_protection.vue")
          },
          {path: "cases_detail",
              component: () => import("@/views/technical_services/smart_environmental_protection/cases_detail.vue")
          },
          {
            path: "/technical",
            redirect: "/technical/consultants"
          }
        ]
      },
      {
          path: "news",
          component: () => import("@/views/news_core/index.vue"),
          children: [
            {
              path: "center",
              component: () => import("@/views/news_core/news/news.vue")
            },
            {
              path: "news_detail",
              component: () => import("@/views/news_core/news/news_detail.vue")
            },
            {
              path: "projects_detail",
              component: () => import("@/views/news_core/news/projects_detail.vue")
            },
            {
              path: "/news",
              redirect: "/news/center"
            }
          ]
      },
      
      {
        path: "join",
        component: () => import("@/views/join_feiyuan/index.vue")
      },
      {
        path: "/",
        redirect: "/home"
      },
    ]},
    {
      path:"*",
      component:notFind
    }
  ]
  
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  
  export default router
 
